module.exports = __webpack_public_path__ + "static/img/new-7.8d918218.jpg";